module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("拖放排序")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("for循环的key不能使用order,因为order排序后数组的第一个元素对应的值总是0")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "list"
  }, [_c('draggable', {
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, _vm._l((_vm.list), function(i) {
    return _c('div', {
      key: i.name,
      staticClass: "item",
      attrs: {
        "order": i.order
      }
    }, [_vm._v("\n                    " + _vm._s(i.name) + "\n                ")])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "ml20"
  }, [_c('h4', [_vm._v(" 结果")]), _vm._v(" "), _c('pre', {
    staticStyle: {}
  }, [_vm._v(_vm._s(JSON.stringify(_vm.list, null, 4)))])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("add")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3806b30f"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/draggable.vue
// module id = 103
// module chunks = 1